import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/components/ui/tooltip';
import React, { useState } from 'react';
import { clsx } from 'clsx';

export const AiKnowledgeBaseToolTip = ({
  trigger,
  content,
  side = 'left' as 'top' | 'right' | 'bottom' | 'left',
  triggerClassName,
  contentClassName,
}: {
  trigger: React.ReactNode;
  content: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  triggerClassName?: string;
  contentClassName?: string;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <TooltipProvider>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger
          onClick={() => setOpen(true)}
          asChild
          className={clsx('cursor-pointer', triggerClassName)}
        >
          {trigger}
        </TooltipTrigger>
        <TooltipContent
          side={side}
          className={clsx(contentClassName, 'max-w-2xl select-none z-30')}
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
